import RootRequest from "./RootRequest";

export default class UserRequest extends RootRequest {
  get apiResource() {
    return "api/user";
  }
}

export const userRequest = new UserRequest();
